import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6 text-green-700">{t("privacy.title")}</h1>

      <p className="mb-4 text-gray-700">
        {t("privacy.intro")}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section1_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section1_text")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section2_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section2_intro")}</p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>{t("privacy.section2_point1")}</li>
        <li>{t("privacy.section2_point2")}</li>
        <li>{t("privacy.section2_point3")}</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section3_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section3_text")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section4_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section4_text")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section5_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section5_text")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-3 text-gray-800">{t("privacy.section6_title")}</h2>
      <p className="mb-4 text-gray-700">{t("privacy.section6_text")}</p>

      <p className="mt-6 text-gray-600 text-sm">
        {t("privacy.last_update")}
      </p>
    </div>
  );
};

export default PrivacyPolicy;
